import IMenuItemBody from "../../../interfaces/IMenuItemBody";
import { IMenuData, IMenuFormData } from "../types";

export const SET_FILTER_STATE = "SET_FILTER_STATE";

export function setFilterState(filterState: any) {
    return {
        type: SET_FILTER_STATE,
        payload: filterState
    };
}

export const SET_MENU_ITEMS = "SET_MENU_ITEMS";

export function setMenuItems(menuItemsList: IMenuData[]) {
    return {
        type: SET_MENU_ITEMS,
        payload: menuItemsList
    };
}



export const SET_SELECTED_MENU_ITEMS = "SET_SELECTED_MENU_ITEMS";

export function setSelectedMenuItems(selectedMenuItemsList: IMenuItemBody[]) {
    return {
        type: SET_SELECTED_MENU_ITEMS,
        payload: selectedMenuItemsList
    };
}


export const SET_FORM_DATA = "SET_FORM_DATA";

export function setMenuFormData(menuFormData: IMenuFormData) {
    return {
        type: SET_FORM_DATA,
        payload: menuFormData
    };
}

export const UPDATE_MENU_POSITION = "UPDATE_MENU_POSITION";
export function updateMenuItemPositions(menuItem: string[]) {
    return {
        type: UPDATE_MENU_POSITION,
        payload: menuItem
    }
}
export const SET_MENU_TIMING = "SET_MENU_TIMING";
export function setMenuTiming(timingObj: Record<string, { start: string, end: string }[]>) {
    return {
        type: SET_MENU_TIMING,
        payload: timingObj
    }
}